/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/assets/js/modules/in_page_transition.js":
/*!*****************************************************!*\
  !*** ./src/assets/js/modules/in_page_transition.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InPageTransitionInit: () => (/* binding */ InPageTransitionInit)
/* harmony export */ });
var InPageTransitionInit = function InPageTransitionInit() {
  /*
   * ページ内遷移
   */

  var headerHeight = document.querySelector('.header').offsetHeight;
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var targetId = this.getAttribute('href').substring(1);
      var targetElement = document.getElementById(targetId);
      if (targetElement) {
        event.preventDefault();
        var targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
};


/***/ }),

/***/ "./src/assets/js/modules/open_content.js":
/*!***********************************************!*\
  !*** ./src/assets/js/modules/open_content.js ***!
  \***********************************************/
/***/ (() => {

document.addEventListener('DOMContentLoaded', function () {
  var faqContents = document.querySelectorAll('.faq_content');
  faqContents.forEach(function (content) {
    content.addEventListener('click', function () {
      this.classList.toggle('is-current');
    });
  });
});

/***/ }),

/***/ "./src/assets/js/modules/ua.js":
/*!*************************************!*\
  !*** ./src/assets/js/modules/ua.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   forDesktopOS: () => (/* binding */ forDesktopOS),
/* harmony export */   getBrowser: () => (/* binding */ getBrowser),
/* harmony export */   getOS: () => (/* binding */ getOS),
/* harmony export */   setUserAgent: () => (/* binding */ setUserAgent)
/* harmony export */ });
var getBrowser = function getBrowser() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  var ua = '';
  if (userAgent.indexOf('opera') !== -1) {
    ua = 'opera';
  } else if (userAgent.indexOf('edge') !== -1) {
    ua = 'edge';
  } else if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
    ua = 'ie';
  } else if (userAgent.indexOf('chrome') !== -1) {
    ua = 'chrome';
  } else if (userAgent.indexOf('safari') !== -1) {
    ua = 'safari';
  } else if (userAgent.indexOf('firefox') !== -1) {
    ua = 'firefox';
  } else if (userAgent.indexOf('gecko') !== -1) {
    ua = 'gecko';
  }
  return ua;
};
var getOS = function getOS() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  var ua = '';
  if (userAgent.indexOf('iphone') !== -1) {
    ua = 'iphone';
  } else if (userAgent.indexOf('ipad') !== -1) {
    ua = 'ipad';
  } else if (userAgent.indexOf('android') !== -1) {
    ua = 'android';
  } else if (userAgent.indexOf('windows') !== -1) {
    ua = 'win';
  } else if (userAgent.indexOf('macintosh') !== -1) {
    ua = 'mac';
  }
  return ua;
};
var forDesktopOS = function forDesktopOS() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.indexOf('windows') !== -1 || userAgent.indexOf('macintosh') !== -1;
};
var setUserAgent = function setUserAgent() {
  var body = document.querySelector('body');
  body.classList.add("is-".concat(getBrowser()));
  body.classList.add("is-".concat(getOS()));
  body.classList.add("is-".concat(forDesktopOS() ? 'for-pc' : 'for-sp'));
};


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/assets/js/app.js ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_ua__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/ua */ "./src/assets/js/modules/ua.js");
/* harmony import */ var _modules_open_content__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/open_content */ "./src/assets/js/modules/open_content.js");
/* harmony import */ var _modules_open_content__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_open_content__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_in_page_transition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/in_page_transition */ "./src/assets/js/modules/in_page_transition.js");



var loadCommonInit = function loadCommonInit() {
  (0,_modules_ua__WEBPACK_IMPORTED_MODULE_0__.setUserAgent)();
  (0,_modules_in_page_transition__WEBPACK_IMPORTED_MODULE_2__.InPageTransitionInit)();
};
window.addEventListener('DOMContentLoaded', function () {
  loadCommonInit();
});
})();

/******/ })()
;
//# sourceMappingURL=lp241107app.js.map